import { generatePDFOfferRequest } from "@common";
import { Dispatch } from "redux";
import { all, put, takeEvery } from "redux-saga/effects";
import { generatePDFOfferAction, generatePDFOfferActionError, generatePDFOfferActionFinished } from "./actions";
import { openNotificationAction } from "@store";

function* downloadSaga(action: typeof generatePDFOfferAction.typeInterface) {
    try {
        let date = new Date()
            .toJSON()
            .slice(0, 10)
            .split("-")
            .reverse()
            .join("/");

        const file: { content: string } = yield* generatePDFOfferRequest.saga({
            clientId: action.clientId,
            campaignId: action.campaignId
        });

        const dataUriStr = `data:application/pdf;base64,${file.content}`;

        const href = document.createElement("a");
        document.body.appendChild(href);
        href.href = dataUriStr; // windowUrl;
        href.download = `Adello-Offer-${date}.pdf`;
        href.click();
        document.body.removeChild(href);

        yield put(generatePDFOfferActionFinished());
    } catch (e) {
        console.error(e);

        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "Something went wrong on generating process, please try again later."
            })
        );
        yield put(generatePDFOfferActionError());
    }
}

export function* downloadpdfSaga(dispatch: Dispatch) {
    yield all([takeEvery(generatePDFOfferAction.type, downloadSaga)]);
}
